/**
* 左边菜单
*/
<template>
  <div>
    <el-menu
      :collapse="true"
      collapse-transition
      unique-opened
      class="el-menu-vertical-demo"
      background-color="#282d42"
      active-text-color="#848391"
      text-color="#848391"
    >
      <div class="logobox"><img class="logoimg" src="../assets/img/logo.png" alt=""/></div>
      <!-- <el-menu-item v-for="(menu,index) in allmenu" :key="index">
        <span>{{menu.title}}</span>
      </el-menu-item> -->
      <div>
        <el-submenu index="/home/rangking" class="mysubmit">
          <template slot="title">
             <i class="el-icon-zhibiao" ></i>
            <span slot="title">年度指标累计同比</span>
          </template>
              <el-menu-item :index="menu.title" v-for="(menu ,index) in allmenu" :key="index" @click="jumrangking(menu)">{{menu.title}}</el-menu-item>
        </el-submenu>
        <el-submenu index="/home/home">
          <template slot="title">
            <i class="el-icon-zhibiao1" ></i>
            <span slot="title">月度指标累计同比</span>
          </template>
          <el-menu-item-group>
              <el-menu-item :index="menu.title+15" v-for="(menu ,index) in allmenu" :key="index" @click="jumpHome(menu)">{{menu.title}}</el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <el-submenu index="3">
          <template slot="title">
            <i class="el-icon-banbenduibi" ></i>
            <span slot="title">年度城与全国倍数对比</span>
          </template>
          <el-menu-item-group>
              <el-menu-item :index="menu.title+30" v-for="(menu ,index) in allmenu" :key="index" @click="jumpyearc(menu)">{{menu.title}}</el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <el-submenu index="4">
          <template slot="title">
            <i class="el-icon-duibi"></i>
            <span slot="title">月度城与全国倍数对比</span>
          </template>
          <el-menu-item-group>
              <el-menu-item :index="menu.title+45" v-for="(menu ,index) in allmenu" :key="index" @click="jumpmouth(menu)">{{menu.title}}</el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <el-submenu index="5">
          <template slot="title">
            <i class="el-icon-duibi1"></i>
            <span slot="title">年度城与全国同比对比</span>
          </template>
          <el-menu-item-group>
              <el-menu-item :index="menu.title+60" v-for="(menu ,index) in allmenu" :key="index" @click="jumpyearct(menu)">{{menu.title}}</el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <el-submenu index="6">
          <template slot="title">
            <i class="el-icon-tandem"></i>
            <span slot="title">月度城与全国同比对比</span>
          </template>
          <el-menu-item-group>
              <el-menu-item :index="menu.title+75" v-for="(menu ,index) in allmenu" :key="index" @click="jumpmouthct(menu)">{{menu.title}}</el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <el-menu-item index="1-1"  @click="jumpread()">
          <i class="el-icon-xiaoshouguanli"></i>
            <span style="margin-left:5px;font-size:15px">开工销售比</span>
          </el-menu-item>
      </div>
    </el-menu>
  </div>
</template>
<script>
  import {gettargets} from "../api/userMG";

  export default {
    name: "leftnav",
    data() {
      return {
        mysubmit:'mysubmit',
        collapsed: true,
        disabled: false,
        newpath:'',
        oldpath:'',
        // city_id:1,
        allmenu: [],
        allmenu1:[]
      };
    },
    watch:{
      $route:{
      handler(val,oldval){

        this.newpath=val.path+""
        this.$root.Bus.$emit('path',val.path)

        // this.oldpath=oldva.path+""
        // console.log(this.newpath);//新路由信息
        // console.log(oldval.path);//老路由信息
      },
      // 深度观察监听
      deep: true
    }
    },
    methods: {
      jumrangking(menu){
        if (this.$route.path=='/home/rangking') {
          if (this.$route.query.target_id!=menu.target_id) {
            this.$root.Bus.$emit('target_id',menu.target_id) 
            
            this.$router.push({path: '/home/rangking', query: {target_id: menu.target_id}})
          }
        }else{
          this.$root.Bus.$off('target_id');
          this.$root.Bus.$emit('target_id',menu.target_id)
          this.$router.push({path: '/home/rangking', query: {target_id: menu.target_id}})
        }
            
          
      },
      jumpHome(menu){
        if (this.$route.path=='/home/home') {
          if (this.$route.query.target_id!=menu.target_id) {
            this.$root.Bus.$emit('target_id',menu.target_id) 
            this.$router.push({path: '/home/home', query: {target_id: menu.target_id}})
          }
        }else{
          this.$root.Bus.$off('target_id');
          this.$root.Bus.$emit('target_id',menu.target_id)
          this.$router.push({path: '/home/home', query: {target_id: menu.target_id}})
        }
      },
      jumpread(menu){
        if (this.$route.path!='/home/reading') {
           this.$router.push({path: '/home/reading'})
        }
      },
      jumpyearc(menu){
         if (this.$route.path=='/home/year_city') {
          if (this.$route.query.target_id!=menu.target_id) {
            this.$root.Bus.$emit('target_id',menu.target_id) 
            this.$router.push({path: '/home/year_city', query: {target_id: menu.target_id}})
          }
        }else{
          this.$root.Bus.$off('target_id');
          this.$root.Bus.$emit('target_id',menu.target_id)  
          this.$router.push({path: '/home/year_city', query: {target_id: menu.target_id}})
        }
          
      },
      jumpmouth(menu){
         if (this.$route.path=='/home/mouth') {
          if (this.$route.query.target_id!=menu.target_id) {
            this.$root.Bus.$emit('target_id',menu.target_id) 
            this.$router.push({path: '/home/mouth', query: {target_id: menu.target_id}})
          }
        }else{
          this.$root.Bus.$off('target_id');
          this.$root.Bus.$emit('target_id',menu.target_id) 
          this.$router.push({path: '/home/mouth', query: {target_id: menu.target_id}})
        }
      },
       jumpyearct(menu){
          if (this.$route.path=='/home/year_ct') {
          if (this.$route.query.target_id!=menu.target_id) {
            this.$root.Bus.$emit('target_id',menu.target_id)  
            this.$router.push({path: '/home/year_ct', query: {target_id: menu.target_id}})
          }
        }else{
          this.$root.Bus.$off('target_id');
          this.$root.Bus.$emit('target_id',menu.target_id)  
          this.$router.push({path: '/home/year_ct', query: {target_id: menu.target_id}})
        }
      },
       jumpmouthct(menu){
          if (this.$route.path=='/home/mouth_ct') {
          if (this.$route.query.target_id!=menu.target_id) {
          this.$root.Bus.$emit('target_id',menu.target_id)  
          this.$router.push({path: '/home/mouth_ct', query: {target_id: menu.target_id}})
          }
        }else{
          this.$root.Bus.$off('target_id');
          this.$root.Bus.$emit('target_id',menu.target_id) 
          this.$router.push({path: '/home/mouth_ct', query: {target_id: menu.target_id}})
        }
      },
      // toggle(target_id,name){
      //   this.$root.Bus.$emit('target_id',target_id)
      //   this.$root.Bus.$emit('name',name)
      // },
      getMenuList() {
        gettargets().then((res) => {
          if (res.errno === 0) {
            this.allmenu1 = res.data;
            for(var i in this.allmenu1){
              var obj={
                title:this.allmenu1[i],
                target_id:i
              }
              this.allmenu.push(obj)
            }
          } else if (res.errno === 401) {
            this.$store.dispatch("LogOut").then(() => {
              location.reload(); // 为了重新实例化vue-router对象 避免bug
            });
          } else {
            this.$message.error(res.error);
          }
        });
      },
    },
    // 创建完毕状态(里面是操作)
    created() {
    },

    mounted() {
      this.getMenuList()
    },
    computed:{
      defaultActive() {
       if (pathName == pathName) {
        let path =`/home/${pathName}`;
        return path;
      }
    }
    }
  };
</script>
<style>
.el-icon-arrow-right:before {
    /* content: "\E6E0"; */
    content: none;
}
  .logobox {
    height: 40px;
    line-height: 40px;
    color: #9d9d9d;
    font-size: 20px;
    text-align: center;
    padding: 10px 0px;
    overflow: hidden;
    background-color: #1f2334;
  }

  /* .logobox{
    padding-left: 7px;
  } */
  /* .el-menu-item:hover{
    background-color: #fbfbfb !important;
  } */
  .el-menu-item{
    color: rgb(82, 82, 82);
    font-size: 15px;
    font-weight: 400;
  }
  .el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 220px;
    min-height: 400px;
    font-size: 2px;
  }
  .el-menu-vertical-demo:not(.el-menu--collapse) {
    border: none;
    text-align: left;
    /*font-weight: 700;*/
  }
.el-menu-vertical-demo{
  border: none;
}

    /* .el-menu-item.is-active {
    color: red;
    background: #373e59 !important;
    font-weight: 600;
    font-size: 15px;
    border-right: 2px solid #2b52e9;
  } */

  .el-submenu__title,
  .el-submenu .el-menu-item {
    height: 60px;
    line-height: 60px;
    font-size: 15px;
  }

  .el-menu-item {
    display: flex;
    align-items: center;
    font-size: 13px;
    height: 40px !important;
  }
.el-menu-item.is-active {
    background: #373e59!important;
    color: #ffffff!important;
}
/* .el-menu-item:focus {
    outline: 0;
    background-color: #ecf5ff !important;
} */
  .navigation span {
    cursor: pointer;
  }

  .el-menu-item span{
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .el-menu-item:hover {
    background: #373e59 !important;
    color: #ffffff!important;
  }

  .el-menu-item:hover i {
    color: #cecdd3!important;
  }
  .el-submenu__title:hover {
    background: #373e59!important;
  }
 
  .el-submenu__title:hover i {
    color: #ffffff !important;
  }
  .el-submenu__title.is-active {
    color: #ffffff !important;
  }


  .el-submenu__title:hover span {
    color: #ffffff !important;
  }

  .element-icons {
    margin-right: 5px;
  }

  .el-menu-item i {
    color:#888c9c
  }

  .el-submenu__title i {
    color:#888c9c
  }
</style>



// WEBPACK FOOTER //
// src/components/leftnav.vue